var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{ref:"button",staticClass:"btn btn-info",on:{"click":function($event){$event.preventDefault();return _vm.add.apply(null, arguments)}}},[_c('i',{staticClass:"fa fa-fw fa-plus",attrs:{"aria-hidden":"true"}}),_vm._t("default",function(){return [_vm._v("Dodaj wiersz")]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }